/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */
import BaseObject from "@shared/BaseObject.js";
import {debounce} from 'vue-debounce'

export default class Debouncer extends BaseObject {

	isDirty: boolean = false
	callback: Function = null

	constructor(callback, delay = 5000) {
		super();
		if(callback){
			this.setup(callback, delay)
		}
	}

	setup(callback, delay){
		if(this.onChangeDebouncedInternal && this.onChangeDebouncedInternal.clear){
			this.onChangeDebouncedInternal.clear()
		}
		this.callback = callback
		if(delay > 0){
			this.onChangeDebouncedInternal = debounce(this.onChangeDebouncedInternalOriginal.bind(this), delay)
			// console.log("this.onChangeDebouncedInternal = ", this.onChangeDebouncedInternal)
			// console.log("this.onChangeDebouncedInternal = ", this.onChangeDebouncedInternal.cancel)
			this.onChangeDebouncedInternal.cancel()
		} else {
			this.onChangeDebouncedInternal = this.onChangeDebouncedInternalOriginal
		}
	}

	onChangeDebounced(...args){
		this.isDirty = true
		// console.log("Debouncer: onChangeDebounced, args = ", this.args)
		console.log("Debouncer: onChangeDebounced, isDirty = ", this.isDirty)
		this.onChangeDebouncedInternal(args)
	}

	onChangeImmediate(...args){
		// console.log("Debouncer: onChangeDebounced, args = ", this.args)
		console.log("Debouncer: onChangeImmediate, isDirty = ", this.isDirty)
		if(this.isDirty){
			this.isDirty = false
			return this.callback(...args)
		}
	}

	onChangeDebouncedInternalOriginal(...args){
		console.log("Debouncer: onChangeDebouncedInternalOriginal = ", ...args)
		this.onChangeImmediate(args)
	}


}
